import { ColDef } from '@ag-grid-community/core';
import { ForgeIcon, ForgeTooltip } from '@tylertech/forge-react';
import { OrderConfig, SortDirection } from 'common/visualizations/vif';
import React from 'react';
import { createRoot } from 'react-dom/client';
import { getCurrentSort } from './SortHelpers';
import { I18n } from 'common/i18n';

export const renderSortIconTooltip = () => {
  return (
    <ForgeTooltip placement="bottom" className="sort-tooltip">
      {I18n.t('shared.visualizations.charts.table.header_multisort_helper_text')}
    </ForgeTooltip>
  );
};
export const renderIcon = (
  name: string,
  classNames: string = 'ag-sort-indicator-icon ag-custom-header-icon',
) => {
  const container = document.createElement('span');
  container.className = classNames;
  createRoot(container).render(
    <>
      <ForgeIcon external external-type="standard" name={name} />
      {renderSortIconTooltip()}
    </>,
  );
  return container;
};

export interface GetSortIconsProps {
  columnName: string;
}

export const createGetSortIcons = (orderConfig: OrderConfig[]) => {
  return (props: GetSortIconsProps): Partial<ColDef['icons']> => {
    const { columnName } = props;
    const currentSort: SortDirection = getCurrentSort({ orderConfig, columnName });
    const iconMap: Record<string, string> = {
      descending: 'arrow_downward',
      ascending: 'arrow_upward',
    };
    return {
      sortAscending: () => {
        return renderIcon(iconMap[currentSort as string] || 'swap_vert');
      },
      sortDescending: () => {
        return renderIcon(iconMap[currentSort as string] || 'swap_vert');
      },
      sortUnSort: () => {
        return renderIcon('notes');
      },
    };
  };
};

interface SortIconReturnType {
  [key: string]: string | ((...args: any[]) => any);
}

export interface ISortIcons {
  (props: GetSortIconsProps): Partial<SortIconReturnType> | undefined;
}
